import React from 'react';
import { useLazyImage } from '../hooks/useLazyImage';

/**
 * Drop-in replacement for <img> that defers loading until the element
 * scrolls within 200px of the viewport via IntersectionObserver.
 *
 * Use for ALL images OUTSIDE the hero stage (#hero-stage / loader / parallax),
 * which must remain directly rendered for the RAF-player pipeline.
 *
 * Props:
 *   src     - imported / required image source (string)
 *   alt     - alt text
 *   eager   - if true, load immediately (skip observer)
 *   ...rest - passed through to the <img>
 */
export function LazyImage({ src, alt, className, eager = false, ...rest }) {
  const [imgRef, resolvedSrc] = useLazyImage(src, { eager });
  return (
    <img
      ref={imgRef}
      src={resolvedSrc || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E'}
      data-src={resolvedSrc ? undefined : src}
      alt={alt || ''}
      className={className}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  );
}

export default LazyImage;
